"use strict";

exports.__esModule = true;
exports["default"] = exports.QuoteText = exports.HtmlBlockquote = exports.Blockquote = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var blockquotePosition = function blockquotePosition(props) {
  var styles = {
    full: (0, _styledComponents.css)(["color:", ";padding-right:50px;"], (0, _styles.colors)("text-hover", props)),
    inline: (0, _styledComponents.css)(["color:", ";"], (0, _styles.colors)("text-hover", props)),
    left: (0, _styledComponents.css)([""]),
    right: (0, _styledComponents.css)(["color:", ";border-radius:12px;background-color:", ";"], (0, _styles.colors)("text-light", props), (0, _styles.colors)("background-highlight", props))
  };
  return styles[props.position];
};

var quoteTextPosition = function quoteTextPosition(props) {
  var styles = {
    full: (0, _styledComponents.css)([""]),
    inline: (0, _styledComponents.css)(["color:", ";border-left:2px solid ", ";padding-left:", "px;"], (0, _styles.colors)("text-hover", props), (0, _styles.colors)("border-focus", props), function (_ref) {
      var theme = _ref.theme;
      return theme.spacings[3];
    }),
    left: (0, _styledComponents.css)([""]),
    right: (0, _styledComponents.css)([""])
  };
  return styles[props.position];
};

var QuoteText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "blockquote__QuoteText",
  componentId: "sc-jfk08y-0"
})(["", ";"], function (props) {
  return quoteTextPosition(props);
});
exports.QuoteText = QuoteText;
var Blockquote = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "blockquote__Blockquote",
  componentId: "sc-jfk08y-1"
})(["", ";"], function (props) {
  return blockquotePosition(props);
});
exports.Blockquote = Blockquote;
var Citation = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "blockquote__Citation",
  componentId: "sc-jfk08y-2"
})(["cite{font-style:normal;position:relative;&::before{content:\"-\";position:absolute;left:-15px;}}"]);
var quoteFont = {
  full: {
    fontSize: [9, 10, 11],
    fontWeight: 2,
    lineHeight: 2,
    mb: 2,
    textAlign: "left"
  },
  inline: {
    fontSize: 6,
    fontWeight: 2,
    lineHeight: 2,
    mb: 2,
    textAlign: "left"
  },
  left: {
    fontSize: 6,
    fontWeight: 2,
    lineHeight: 2,
    mb: 2,
    textAlign: "left"
  },
  right: {
    fontSize: 6,
    fontWeight: 2,
    lineHeight: 2,
    mb: 2,
    textAlign: "left"
  }
};
var attributionFont = {
  fontSize: 5,
  fontWeight: 1,
  lineHeight: 3,
  textAlign: "right"
};
var quotePadding = {
  full: {},
  inline: {},
  left: {
    px: 2,
    py: 2
  },
  right: {
    px: 2,
    py: 2
  }
};
var propTypes = {
  /** attribution text  */
  attribution: _propTypes.string,

  /** class name for blockquote  */
  className: _propTypes.string,

  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** block position  */
  position: _propTypes.string,

  /** quote text  */
  text: _propTypes.string
};

var HtmlBlockquote = function HtmlBlockquote(_ref2) {
  var attribution = _ref2.attribution,
      className = _ref2.className,
      dataTestId = _ref2["data-test-id"],
      position = _ref2.position,
      text = _ref2.text;
  return /*#__PURE__*/_react["default"].createElement(Blockquote, _extends({
    className: className,
    "data-test-id": dataTestId,
    flexDirection: "column",
    mx: "auto",
    my: position === "inline" ? 4 : [4, 4, 4, 2],
    position: position,
    tag: "blockquote"
  }, quotePadding[position], {
    width: [1, position === "inline" ? 1 : 3 / 4, 1]
  }), /*#__PURE__*/_react["default"].createElement(QuoteText, _extends({
    position: position
  }, quoteFont[position]), text), attribution ? /*#__PURE__*/_react["default"].createElement(Citation, _extends({
    position: position
  }, attributionFont, {
    pr: position === "inline" ? "20%" : 0
  }), /*#__PURE__*/_react["default"].createElement("cite", null, attribution)) : null);
};

exports.HtmlBlockquote = HtmlBlockquote;
HtmlBlockquote.propTypes = propTypes;
HtmlBlockquote.displayName = "Modules.HtmlBlockquote";
var _default = HtmlBlockquote;
exports["default"] = _default;